import React from 'react';
import { noop, find, isEmpty } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { GLOBAL_LABELS } from 'constants/common';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { singleSelect as SingleSelectView } from './singleSelect.view';
 *
 * // render
 * <SingleSelectView propName='propValue'/>
 */
export const singleSelect = React.forwardRef( ( props, forwardedRef ) => {

    // get selected option
    const selectedOption = find( props.options, { value: props.value } );

    // dynamic class name
    const widgetClassName = classnames( 'ui-single-select', props.className, {
        'ui-single-select--disabled': props.disabled,
        'ui-single-select--empty': isEmpty( selectedOption ),
    } );

    // arrow class name
    const arrowClassName = classnames( 'ui-single-select__arrow', {
        'ui-single-select__arrow--open': props.isPopoverOpen,
    } );

    return (
        <div ref={ forwardedRef } className={ widgetClassName } onClick={ () => props.disabled ? null : props.onPopoverOpen() }>

            {/* selected value */}
            <div className='ui-single-select__value'>
                { selectedOption ? getLabel( selectedOption.title ) : getLabel( GLOBAL_LABELS.DISPLAY_TEXT_SELECT ) }
            </div>

            {/* arrow */}
            <div className={ arrowClassName }>
                <Icon name='downArrow' width='12' height='9' />
            </div>
        </div>
    );
} );

// set display name
singleSelect.displayName = 'singleSelect';

// set default props
singleSelect.defaultProps = {
    options: [],
    value: null,
    disabled: false,
    onPopoverOpen: noop,
};

// prop types
singleSelect.propTypes = {};
